import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
// @ts-ignore
import { AdapterDateFns } from '@emburse/ui-core/dist/AdapterDateFns';
import { EmburseUIProvider } from '@emburse/ui-essentials';
import { AbacusThemeProvider } from '@ReactComponents/Layout/ThemeProvider';
const AbacusEmbarkProvider = function ({ children }) {
    return (_jsx(EmburseUIProvider, Object.assign({ featureFlags: { useNewColorScheme: true, legacyI18nSupport: true, useGridProFeatures: true }, theme: { designToken: AbacusThemeProvider.getThemeOptions(), responsive: { sidebar: true } }, dateLocale: { dateAdapter: AdapterDateFns } }, { children: children })));
};
export { AbacusEmbarkProvider };
